<div class="paginator--container">
    <div *ngIf="currentPage > 1 && !isEn" class="button-wrapper">
        <app-button leftIconSecondaryPath="assets/images/arrow/pagi-left_@2x.png" leftIconPath="assets/images/arrow/pagi-left@2x.png" text="{{language.btn3}}" [outline]="true" (click)="decreasePageNumber()"></app-button>
    </div>
    <div *ngIf="currentPage > 1 && isEn" class="button-wrapper">
        <app-button leftIconSecondaryPath="assets/images/arrow/pagi-left_@2x.png" leftIconPath="assets/images/arrow/pagi-left@2x.png" text="{{language.btn3}}" [outline]="true" (click)="decreasePageNumber()"></app-button>
    </div>
    <span *ngIf="!isEn">หน้า</span>
    <span *ngIf="isEn">Page</span>
    <span class="current-page">{{currentPage}}</span>
    <span *ngIf="!isEn">จาก</span>
    <span *ngIf="isEn">of</span>
    <!-- <span>จาก</span> -->
    <span>{{totalPage}}</span>
    <div *ngIf="currentPage < totalPage && !isEn" class="button-wrapper">
        <app-button rightIconSecondaryPath="assets/images/arrow/pagi-right_@2x.png" rightIconPath="assets/images/arrow/pagi-right@2x.png" text="{{language.btn4}}" [outline]="true" (click)="increasePageNumber()"></app-button>
    </div>
    <div *ngIf="currentPage < totalPage && isEn" class="button-wrapper">
        <app-button rightIconSecondaryPath="assets/images/arrow/pagi-right_@2x.png" rightIconPath="assets/images/arrow/pagi-right@2x.png" text="{{language.btn4}}" [outline]="true" (click)="increasePageNumber()"></app-button>
    </div>
</div>